import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomePageComponent } from './views/home-page/home-page.component';
import { UserHomeComponent } from './views/user-home/user-home.component';
import { authGuard } from './auth/auth-guard.service';
import { UsersPageComponent } from './views/users-page/users-page.component';
import { CustomersPageComponent } from './views/customers-page/customers-page.component';
import { CalendarPageComponent } from './views/calendar-page/calendar-page.component';
import { AppointmentPageComponent } from './views/appointment-page/appointment-page.component';
import { CustomerDetailsPageComponent } from './views/customer-details-page/customer-details-page.component';
import { HorseDetailsPageComponent } from './views/horse-details-page/horse-details-page.component';
import { NewBookingInfoComponent } from './views/new-booking-info/new-booking-info.component';
import { MyAccountComponent } from './views/my-account/my-account.component';
import { CustomerLoginComponent } from './views/customer-login/customer-login.component';
// import { redirectLoggedInTo, redirectUnauthorizedTo } from '@angular/fire/auth-guard';
import { SettingsComponent } from './views/settings/settings.component';

// const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(['login']);
// const redirectLoggedInToSendEmail = () => redirectLoggedInTo(['my-account']);

const routes: Routes = [
  { path : '', component: HomePageComponent },
  { path : 'home', component: UserHomeComponent, canActivate: [authGuard], data: { title: 'My Account'} },
  { path : 'users', component: UsersPageComponent, canActivate: [authGuard], data: { title: 'Users'} },
  { path : 'customers', component: CustomersPageComponent, canActivate: [authGuard], data: { title: 'Customers'} },
  { path : 'calendar', component: CalendarPageComponent, canActivate: [authGuard], data: { title: 'Calendar'} },
  { path : 'appointment/:id', component: AppointmentPageComponent, canActivate: [authGuard], data: { title: 'Appointment'} },
  { path : 'customer/:id', component: CustomerDetailsPageComponent, canActivate: [authGuard], data: { title: 'Customer'} },
  { path : 'horse/:id', component: HorseDetailsPageComponent, canActivate: [authGuard], data: { title: 'Horse'} },
  { path : 'booking/new/info/:id', component: NewBookingInfoComponent, data: { title: 'New Booking Information',} },
  { path : 'my-account', component: MyAccountComponent, data: { title: 'My Account'} },
  { path : 'login', component: CustomerLoginComponent, data: { title: 'Customer Login'} },
  { path : 'settings', component: SettingsComponent, canActivate: [], data: { title: 'Settings'} },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
